import { render, staticRenderFns } from "./ItemWriteLink.vue?vue&type=template&id=1c7a4308&scoped=true&"
import script from "./ItemWriteLink.vue?vue&type=script&lang=js&"
export * from "./ItemWriteLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7a4308",
  null
  
)

export default component.exports